export default __webpack_public_path__ + "static/media/coleta-mujer-verde.ba00a5c4.png";